module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "op-tabcontent"
  }, _vm._l((_vm.content.tabs), function(tab, i) {
    return _c('div', {
      staticClass: "op-tabcontent__item",
      attrs: {
        "id": "op-tabcontent-" + i
      }
    }, [(i % 2 == 0) ? _c('div', {
      staticClass: "op-tabcontent__content"
    }, [_c('div', {
      staticClass: "op-tabcontent__left"
    }, [_c('img', {
      attrs: {
        "src": tab.tabcontent.image
      }
    }), _c('img', {
      attrs: {
        "src": tab.tabcontent.image_2
      }
    })]), _c('div', {
      staticClass: "op-tabcontent__right"
    }, [(tab.tabcontent.title) ? _c('div', {
      staticClass: "op-tabcontent__title"
    }, [_vm._v(_vm._s(tab.tabcontent.title))]) : _vm._e(), _c('div', {
      staticClass: "op-tabcontent__text",
      domProps: {
        "innerHTML": _vm._s(tab.tabcontent.text)
      }
    }, [_vm._v(_vm._s(tab.tabcontent.text))]), (tab.tabcontent.link_01) ? _c('a', {
      staticClass: "btn-main op-tabcontent__btn",
      attrs: {
        "href": tab.tabcontent.link_01,
        "target": "_blank"
      }
    }, [_vm._v(_vm._s(tab.tabcontent.link_text_01))]) : _vm._e(), (tab.tabcontent.link_02) ? _c('a', {
      staticClass: "btn-main op-tabcontent__btn",
      attrs: {
        "href": tab.tabcontent.link_02,
        "target": "_blank"
      }
    }, [_vm._v(_vm._s(tab.tabcontent.link_text_02))]) : _vm._e()])]) : _c('div', {
      staticClass: "op-tabcontent__content"
    }, [_c('div', {
      staticClass: "op-tabcontent__left"
    }, [_c('div', {
      staticClass: "op-tabcontent__title op-tabcontent__title--option"
    }, [_vm._v(_vm._s(tab.tabcontent.title))]), _c('div', {
      staticClass: "op-tabcontent__text",
      domProps: {
        "innerHTML": _vm._s(tab.tabcontent.text)
      }
    }, [_vm._v(_vm._s(tab.tabcontent.text) + "  ")]), _c('OPInnerTabs', {
      attrs: {
        "content": _vm.content.tabs[i]
      }
    })], 1), _c('div', {
      staticClass: "op-tabcontent__right"
    }, [_c('img', {
      attrs: {
        "src": tab.tabcontent.image
      }
    }), _c('img', {
      attrs: {
        "src": tab.tabcontent.image_2
      }
    })])])])
  }), 0)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-51c2b285","hasScoped":false}!./~/vue-loader/lib/template-compiler/preprocessor.js?engine=pug!./src/components/custom/custom-op-tabs/op-tabcontent/op-tabcontent.pug
// module id = 636
// module chunks = 1